export default {
  title: 'Szczegóły kodu promocyjnego',
  back: 'Powrót do kodów promocyjnych',
  tabs: {
    customers: 'Klienci',
    orders: 'Zamówienia',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Śr. wartość zamówienia',
    customer_adoption: 'Unikalni klienci',
  },
  toasts: {
    failed_to_load_stats: 'Nie udało się załadować statystyk',
  },
};
